var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegramIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 38,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#7A8090"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 15,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7A8090",
  fillRule: "evenodd",
  d: "M36 19c0 9.388-7.612 17-17 17S2 28.388 2 19 9.612 2 19 2s17 7.612 17 17m-16.39-4.45q-2.482 1.031-9.915 4.27-1.206.48-1.265.94c-.065.518.584.722 1.465.998q.18.056.373.12c.868.281 2.035.611 2.642.624q.826.017 1.844-.68 6.945-4.69 7.17-4.74c.106-.024.254-.056.353.034.099.087.089.255.08.3-.066.273-2.608 2.638-3.925 3.862-.41.38-.701.652-.76.714-.134.137-.27.269-.4.395-.808.776-1.411 1.36.034 2.312.694.458 1.25.836 1.803 1.213.605.412 1.208.823 1.99 1.336.199.13.389.265.574.396.704.503 1.338.954 2.12.883.453-.043.923-.469 1.161-1.743.563-3.011 1.67-9.534 1.927-12.223a3 3 0 0 0-.028-.668.72.72 0 0 0-.244-.46c-.203-.166-.517-.202-.659-.199-.639.011-1.62.353-6.34 2.316",
  clipRule: "evenodd"
})));
export default SvgTelegramIcon;